import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const CloneIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    viewBox="0 0 1200 1200"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color}>
      <path d="M1039.2 30H410.4c-72 0-130.8 58.801-130.8 130.8v120h-120c-72 0-130.8 58.801-130.8 130.8v628.8c0 72 58.801 130.8 130.8 130.8h628.8c72 0 130.8-58.801 130.8-130.8v-120h120c72 0 130.8-58.801 130.8-130.8V160.8c0-72-58.801-130.8-130.8-130.8zM844.8 1039.2c0 31.199-25.199 56.398-56.398 56.398l-627.6.004c-31.199 0-56.398-25.2-56.398-56.398l-.004-628.8c0-31.2 25.2-56.398 56.398-56.398h628.8c31.2 0 56.398 25.199 56.398 56.398l.004 628.8zm250.8-249.6c0 31.199-25.199 56.398-56.398 56.398h-120l-.004-435.6c0-72-58.8-130.8-130.8-130.8l-434.4.004v-120c0-31.2 25.2-56.398 56.398-56.398h628.8c31.2 0 56.398 25.199 56.398 56.398z" />
      <path d="M672 687.6H512.4V528c0-20.398-16.801-37.199-37.199-37.199S438.002 507.602 438.002 528v159.6h-160.8c-20.398 0-37.199 16.801-37.199 37.199s16.801 37.199 37.199 37.199h159.6v159.6c0 20.398 16.801 37.199 37.199 37.199s37.199-16.801 37.199-37.199v-159.6H672c20.398 0 37.199-16.801 37.199-37.199 0-20.402-16.801-37.199-37.199-37.199z" />
    </g>
  </svg>
);

CloneIcon.propTypes = propTypes;

export default CloneIcon;
